import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

interface NewsroomAccordionHeaderProps {
  readonly date: string | undefined;
  readonly headline: string | undefined;
}

export const NewsroomAccordionHeader = ({
  date,
  headline,
}: NewsroomAccordionHeaderProps) => {
  const t = useTranslations();
  return (
    <div className="max-w-[80vw]" data-cy="newsroom-header-container">
      <TypographyV3
        className="text-sm font-light text-gray-400"
        data-cy="newsroom-date"
      >
        {t(date ?? '')}
      </TypographyV3>
      <TypographyV3
        variant="h6"
        Element="h3"
        weight="normal"
        data-cy="newsroom-headline"
      >
        {t.rich(headline ?? '')}
      </TypographyV3>
    </div>
  );
};
